import type { Booking, Quote } from '../types/booking';

const ADDRESS = 'Siri Residence, Soi Sukhumvit 24, Unit 12B, Phrom Phong';

export const quotes: Quote[] = [
  {
    id: 'q-1004',
    version: 2,
    chefId: 'chef-priya',
    customerId: 'cus-dana',
    bookingId: 'bk-1004',
    menuId: 'menu-priya-thali',
    menuName: 'South Indian thali night',
    fulfillment: 'in_home',
    guests: 6,
    date: '2026-09-14',
    time: '19:00',
    hours: 4,
    groceries: 'included',
    lines: [
      { id: 'menu', kind: 'menu', label: 'South Indian thali night', detail: '6 guests × 1,100', qty: 6, unitPrice: 1100, amount: 6600 },
      { id: 'extra-hours', kind: 'addon', label: 'Additional service hour', detail: '1 hr beyond the 3 included', qty: 1, unitPrice: 850, amount: 850 },
      { id: 'priya-chai', kind: 'addon', label: 'Filter coffee & chai service', detail: '6 guests × 190', qty: 6, unitPrice: 190, amount: 1140 },
      { id: 'travel', kind: 'travel', label: 'Travel beyond included area', detail: '3 km × 20 · 9 km included', qty: 3, unitPrice: 20, amount: 60 },
    ],
    subtotal: 8650,
    serviceFee: 865,
    tax: 665,
    total: 10180,
    depositPercent: 25,
    depositDue: 2545,
    balanceDue: 7635,
    expiresAt: '2026-09-05T18:00:00.000Z',
    status: 'pending',
    note: 'Second version — I split the sambar into a mild pot for Ing and a hotter one for the adults, and left the cashew garnish off the payasam entirely.',
    allergiesAcknowledged: true,
    createdAt: '2026-09-02T16:20:00.000Z',
  },
  {
    id: 'q-1004-v1',
    version: 1,
    chefId: 'chef-priya',
    customerId: 'cus-dana',
    bookingId: 'bk-1004',
    menuId: 'menu-priya-thali',
    menuName: 'South Indian thali night',
    fulfillment: 'in_home',
    guests: 6,
    date: '2026-09-14',
    time: '19:00',
    hours: 3,
    groceries: 'included',
    lines: [
      { id: 'menu', kind: 'menu', label: 'South Indian thali night', detail: '6 guests × 1,100', qty: 6, unitPrice: 1100, amount: 6600 },
      { id: 'travel', kind: 'travel', label: 'Travel beyond included area', detail: '3 km × 20 · 9 km included', qty: 3, unitPrice: 20, amount: 60 },
    ],
    subtotal: 6660,
    serviceFee: 666,
    tax: 513,
    total: 7839,
    depositPercent: 25,
    depositDue: 1960,
    balanceDue: 5879,
    expiresAt: '2026-09-03T18:00:00.000Z',
    status: 'superseded',
    note: 'First pass — three hours, no coffee service.',
    allergiesAcknowledged: true,
    createdAt: '2026-09-01T14:05:00.000Z',
  },
  {
    id: 'q-1003',
    version: 1,
    chefId: 'chef-kenji',
    customerId: 'cus-dana',
    bookingId: 'bk-1003',
    menuId: 'menu-kenji-omakase',
    menuName: 'Counter omakase, eight courses',
    fulfillment: 'in_home',
    guests: 4,
    date: '2026-09-19',
    time: '19:30',
    hours: 4,
    groceries: 'included',
    lines: [
      { id: 'menu', kind: 'menu', label: 'Counter omakase, eight courses', detail: '4 guests × 5,500', qty: 4, unitPrice: 5500, amount: 22000 },
      { id: 'kenji-sake', kind: 'addon', label: 'Sake flight', detail: '4 guests × 1,400', qty: 4, unitPrice: 1400, amount: 5600 },
    ],
    subtotal: 27600,
    serviceFee: 2760,
    tax: 2125,
    total: 32485,
    depositPercent: 40,
    depositDue: 12994,
    balanceDue: 19491,
    expiresAt: '2026-08-30T18:00:00.000Z',
    status: 'accepted',
    note: 'No shellfish anywhere in the sequence — I have replaced the usual botan ebi course with aged kanpachi. Separate boards and knives for the whole service.',
    allergiesAcknowledged: true,
    createdAt: '2026-08-28T15:40:00.000Z',
  },
  {
    id: 'q-1001',
    version: 1,
    chefId: 'chef-elena',
    customerId: 'cus-dana',
    bookingId: 'bk-1001',
    menuId: 'menu-elena-sunday',
    menuName: 'Baan Ploy tasting',
    fulfillment: 'in_home',
    guests: 6,
    date: '2026-08-22',
    time: '19:00',
    hours: 5,
    groceries: 'included',
    lines: [
      { id: 'menu', kind: 'menu', label: 'Baan Ploy tasting', detail: '6 guests × 2,400', qty: 6, unitPrice: 2400, amount: 14400 },
      { id: 'elena-wine', kind: 'addon', label: 'Wine & cocktail pairing', detail: '6 guests × 950', qty: 6, unitPrice: 950, amount: 5700 },
      { id: 'extra-hours', kind: 'addon', label: 'Additional service hour', detail: '1 hr beyond the 4 included', qty: 1, unitPrice: 1200, amount: 1200 },
    ],
    subtotal: 21300,
    serviceFee: 2130,
    tax: 1640,
    total: 25070,
    depositPercent: 30,
    depositDue: 7521,
    balanceDue: 17549,
    expiresAt: '2026-08-12T18:00:00.000Z',
    status: 'accepted',
    note: 'Completely separate wok, board and oil for the shellfish allergy. Mild version of every dish for Ing.',
    allergiesAcknowledged: true,
    createdAt: '2026-08-09T13:10:00.000Z',
  },
  {
    id: 'q-2001',
    version: 1,
    chefId: 'chef-elena',
    customerId: 'cus-rafael',
    bookingId: 'bk-2001',
    menuId: 'menu-elena-weeknight',
    menuName: 'Weeknight Thai table',
    fulfillment: 'in_home',
    guests: 8,
    date: '2026-09-06',
    time: '18:30',
    hours: 2,
    groceries: 'at_cost',
    lines: [
      { id: 'menu', kind: 'menu', label: 'Weeknight Thai table', detail: '8 guests × 1,150', qty: 8, unitPrice: 1150, amount: 9200 },
      { id: 'groceries', kind: 'groceries', label: 'Groceries at cost', detail: 'Billed after the booking with receipts attached', qty: 1, unitPrice: 0, amount: 0 },
    ],
    subtotal: 9200,
    serviceFee: 920,
    tax: 708,
    total: 10828,
    depositPercent: 30,
    depositDue: 3248,
    balanceDue: 7580,
    expiresAt: '2026-08-27T18:00:00.000Z',
    status: 'accepted',
    note: 'Two curries plus the som tam. Receipts go up the same night.',
    allergiesAcknowledged: true,
    createdAt: '2026-08-24T11:00:00.000Z',
  },
];

export function quoteById(id?: string): Quote | undefined {
  return id ? quotes.find((q) => q.id === id) : undefined;
}

export const bookings: Booking[] = [
  {
    id: 'bk-1004',
    ref: 'PA-1004',
    chefId: 'chef-priya',
    customerId: 'cus-dana',
    status: 'quoted',
    occasion: 'Birthday',
    date: '2026-09-14',
    time: '19:00',
    guests: 6,
    fulfillment: 'in_home',
    addressLine: ADDRESS,
    menuName: 'South Indian thali night',
    total: 10180,
    quoteId: 'q-1004',
    createdAt: '2026-08-31T10:12:00.000Z',
    groceryReceipts: [],
    timeline: [
      { status: 'requested', at: '2026-08-31T10:12:00.000Z', note: 'Birthday dinner for 6, mild option needed for a 9-year-old.' },
      { status: 'quoted', at: '2026-09-01T14:05:00.000Z', note: 'Quote v1 sent — ฿7,839' },
      { status: 'quote_revised', at: '2026-09-02T16:20:00.000Z', note: 'Quote v2 sent — added an hour and coffee service' },
    ],
  },
  {
    id: 'bk-1003',
    ref: 'PA-1003',
    chefId: 'chef-kenji',
    customerId: 'cus-dana',
    status: 'confirmed',
    occasion: 'Anniversary',
    date: '2026-09-19',
    time: '19:30',
    guests: 4,
    fulfillment: 'in_home',
    addressLine: ADDRESS,
    menuName: 'Counter omakase, eight courses',
    total: 32485,
    quoteId: 'q-1003',
    createdAt: '2026-08-26T09:00:00.000Z',
    groceryReceipts: [],
    timeline: [
      { status: 'requested', at: '2026-08-26T09:00:00.000Z' },
      { status: 'quoted', at: '2026-08-28T15:40:00.000Z', note: 'Shellfish course replaced' },
      { status: 'confirmed', at: '2026-08-28T20:11:00.000Z', note: 'Deposit of ฿12,994 authorized' },
    ],
  },
  {
    id: 'bk-1005',
    ref: 'PA-1005',
    chefId: 'chef-sofia',
    customerId: 'cus-dana',
    status: 'requested',
    occasion: 'Dinner party',
    date: '2026-10-03',
    time: '19:00',
    guests: 5,
    fulfillment: 'in_home',
    addressLine: ADDRESS,
    createdAt: '2026-09-02T20:40:00.000Z',
    groceryReceipts: [],
    timeline: [{ status: 'requested', at: '2026-09-02T20:40:00.000Z', note: 'Mostly vegetarian, one guest eats fish, one is dairy-free.' }],
  },
  {
    id: 'bk-1001',
    ref: 'PA-1001',
    chefId: 'chef-elena',
    customerId: 'cus-dana',
    status: 'completed',
    occasion: 'Anniversary',
    date: '2026-08-22',
    time: '19:00',
    guests: 6,
    fulfillment: 'in_home',
    addressLine: ADDRESS,
    menuName: 'Baan Ploy tasting',
    total: 25070,
    quoteId: 'q-1001',
    reviewId: 'rev-1',
    createdAt: '2026-08-07T12:00:00.000Z',
    groceryReceipts: [],
    timeline: [
      { status: 'requested', at: '2026-08-07T12:00:00.000Z' },
      { status: 'quoted', at: '2026-08-09T13:10:00.000Z' },
      { status: 'confirmed', at: '2026-08-09T18:22:00.000Z', note: 'Deposit of ฿7,521 authorized' },
      { status: 'in_progress', at: '2026-08-22T22:00:00.000Z' },
      { status: 'completed', at: '2026-08-23T01:30:00.000Z', note: 'Balance of ฿17,549 charged' },
      { status: 'review_left', at: '2026-08-23T09:14:00.000Z', note: '5 stars' },
    ],
  },
  {
    id: 'bk-1002',
    ref: 'PA-0987',
    chefId: 'chef-amara',
    customerId: 'cus-dana',
    status: 'completed',
    occasion: 'Family weekend',
    date: '2026-06-07',
    time: '13:00',
    guests: 12,
    fulfillment: 'in_home',
    addressLine: ADDRESS,
    menuName: 'Isan feast over charcoal',
    total: 21400,
    createdAt: '2026-05-20T15:00:00.000Z',
    groceryReceipts: [],
    timeline: [
      { status: 'requested', at: '2026-05-20T15:00:00.000Z' },
      { status: 'quoted', at: '2026-05-20T17:30:00.000Z' },
      { status: 'confirmed', at: '2026-05-21T08:00:00.000Z' },
      { status: 'completed', at: '2026-06-07T20:00:00.000Z' },
    ],
  },
  {
    id: 'bk-1006',
    ref: 'PA-0902',
    chefId: 'chef-marcus',
    customerId: 'cus-dana',
    status: 'cancelled',
    occasion: 'Condo rooftop party',
    date: '2026-05-30',
    time: '16:00',
    guests: 20,
    fulfillment: 'delivery',
    addressLine: ADDRESS,
    menuName: 'Teochew banquet',
    total: 0,
    createdAt: '2026-05-02T11:00:00.000Z',
    groceryReceipts: [],
    cancellation: { reason: 'Storm — moved indoors and cut numbers', refund: 8200, at: '2026-05-27T10:00:00.000Z' },
    timeline: [
      { status: 'requested', at: '2026-05-02T11:00:00.000Z' },
      { status: 'quoted', at: '2026-05-02T13:40:00.000Z' },
      { status: 'confirmed', at: '2026-05-03T09:00:00.000Z' },
      { status: 'cancelled', at: '2026-05-27T10:00:00.000Z', note: 'Flexible tier — ฿8,200 deposit refunded in full' },
    ],
  },
  {
    id: 'bk-2001',
    ref: 'PA-2001',
    chefId: 'chef-elena',
    customerId: 'cus-rafael',
    status: 'confirmed',
    occasion: 'Dinner party',
    date: '2026-09-06',
    time: '18:30',
    guests: 8,
    fulfillment: 'in_home',
    addressLine: 'The Esse Asoke, Unit 2704, Asok',
    menuName: 'Weeknight Thai table',
    total: 10828,
    quoteId: 'q-2001',
    createdAt: '2026-08-22T18:00:00.000Z',
    groceryReceipts: [
      { id: 'gr-1', label: 'Khlong Toei market — crab, herbs, coconut', amount: 2140, uploadedAt: '2026-09-01T19:00:00.000Z' },
    ],
    timeline: [
      { status: 'requested', at: '2026-08-22T18:00:00.000Z' },
      { status: 'quoted', at: '2026-08-24T11:00:00.000Z' },
      { status: 'confirmed', at: '2026-08-24T14:30:00.000Z', note: 'Deposit of ฿3,248 authorized' },
    ],
  },
  {
    id: 'bk-2002',
    ref: 'PA-2002',
    chefId: 'chef-elena',
    customerId: 'cus-yuki',
    status: 'requested',
    occasion: 'Date night',
    date: '2026-09-21',
    time: '20:00',
    guests: 2,
    fulfillment: 'in_home',
    addressLine: 'Noble Revolve, Unit 1802, Ratchada',
    createdAt: '2026-09-03T08:15:00.000Z',
    groceryReceipts: [],
    timeline: [{ status: 'requested', at: '2026-09-03T08:15:00.000Z', note: 'Wants the weeknight table for two, no dairy.' }],
  },
  {
    id: 'bk-2003',
    ref: 'PA-1988',
    chefId: 'chef-elena',
    customerId: 'cus-nadia',
    status: 'completed',
    occasion: 'Weekly meal prep',
    date: '2026-08-15',
    time: '11:00',
    guests: 5,
    fulfillment: 'delivery',
    addressLine: 'The Met Sathorn, Unit 3105, Sathorn',
    menuName: 'Week of home-style Thai',
    total: 4820,
    createdAt: '2026-08-11T09:00:00.000Z',
    groceryReceipts: [],
    timeline: [
      { status: 'requested', at: '2026-08-11T09:00:00.000Z' },
      { status: 'quoted', at: '2026-08-11T12:00:00.000Z' },
      { status: 'confirmed', at: '2026-08-11T15:00:00.000Z' },
      { status: 'completed', at: '2026-08-15T14:00:00.000Z' },
    ],
  },
  {
    id: 'bk-2004',
    ref: 'PA-2004',
    chefId: 'chef-elena',
    customerId: 'cus-owen',
    status: 'declined',
    occasion: 'Corporate dinner',
    date: '2026-09-10',
    time: '19:00',
    guests: 24,
    fulfillment: 'in_home',
    addressLine: 'Sathorn Square, 14th floor, Sathorn',
    createdAt: '2026-08-29T16:00:00.000Z',
    groceryReceipts: [],
    timeline: [
      { status: 'requested', at: '2026-08-29T16:00:00.000Z' },
      { status: 'declined', at: '2026-08-29T19:20:00.000Z', note: 'Too many covers for one pair of hands — referred to Mei Lin Chow.' },
    ],
  },
];

export function bookingsForCustomer(customerId: string): Booking[] {
  return bookings.filter((b) => b.customerId === customerId);
}

export function bookingsForChef(chefId: string): Booking[] {
  return bookings.filter((b) => b.chefId === chefId);
}
